// extracted by mini-css-extract-plugin
export default {"modal":"AccountBlockModal_modal__nfCaK","body":"AccountBlockModal_body__8wxOM"};